// Whether Kit's composer may take keyboard focus when it appears.
//
// The composer used to carry `autofocus`. Kit's panel lazy-loads its chat into
// a turbo-frame on every page, and Turbo's FrameRenderer focuses the first
// [autofocus] element in a loaded frame unconditionally, so the composer took
// focus from whatever the customer was already typing in. Chat 723: a creator
// clicked "Search sponsors" on /sponsors, started typing, the frame arrived a
// second later, and the rest of the word plus Enter went to Kit ("ruise",
// "window", "prime", ...). Many one-word messages a week landed that way.
//
// The rule now matches the one Turbo applies to streams: take focus only when
// nobody else has it, and never from inside a closed panel, where the
// textarea is invisible but still focusable.
export function composerMayTakeFocus({ activeElement, body, insideClosedPanel }) {
  if (insideClosedPanel) return false;
  return activeElement == null || activeElement === body;
}
